import { Injectable, Type } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationExtras,
  NavigationStart,
  Router,
  RouterEvent,
} from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavService {
  get url() {
    return this._router.url;
  }
  constructor(private _router: Router, private _route: ActivatedRoute) {}

  to(commands: any[], extras?: NavigationExtras) {
    return this._router.navigate(commands, extras);
  }
  start(): Observable<NavigationStart> {
    return this._events([NavigationStart]);
  }
  end(): Observable<NavigationEnd> {
    return this._events([NavigationEnd]);
  }
  private _events<T = RouterEvent>(
    types: Array<Type<RouterEvent>> | Type<RouterEvent>
  ) {
    const eventTypes: Array<Type<RouterEvent>> = Array.isArray(types)
      ? types
      : [types];
    return this._router.events.pipe(
      filter((e) => eventTypes.some((type) => e instanceof type))
    ) as Observable<unknown> as Observable<T>;
  }
}
